
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/faculty",
      function () {
        return require("private-next-pages/admin/faculty/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/faculty"])
      });
    }
  